<template>
  <b-col>
    <b-row>
      <b-col>
        <h2>Баланс</h2>
      </b-col>
      <b-col class="text-right">
        <h2>{{ balance }} ₽</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-3">
        <b-button variant="primary" class="mb-3" v-b-modal.modal-1>
          <i class="ri-upload-line hp-text-color-dark-0 lh-1"
            style="font-size: 16px"></i>&nbsp;Загрузить документы
        </b-button>
      </b-col>
      <b-col class="col-3">
        <b-button variant="primary" class="mb-3 float-right" v-b-modal.modal-2>Пополнить баланс
        </b-button>
      </b-col>
      <b-col class="col-3"/>
      <b-modal
        :id="`modal-1`"
        hide-footer
        header-class="align-items-center pt-reduced pb-reduced"
      >
        <template #modal-header="{ close }">
          <h5 class="mb-0">Заказать счет на оплату</h5>

          <b-button
            variant="text"
            @click="close()"
            class="btn-close bg-transparent p-0 d-flex align-items-center justify-content-center"
            style="min-height: 24px"
          >
            <i
              class="ri-close-line hp-text-color-dark-0 lh-1"
              style="font-size: 24px"
            ></i>
          </b-button>
        </template>
        <ValidationObserver v-slot="{ valid }">
          <b-form class="col-12" @submit="onUpload">
            <b-form-row>
              <validation-provider
                name="Цена"
                :rules="{
                  required: true,
                  regex: /^\d+([\.]\d+)?$/,
                }"
                v-slot="{ dirty, valid, invalid, errors }"
              >
                <b-form-row class="mb-2">
                  <b-col
                    ><label inline class="mr-sm-2" for="amount-input"
                      >Введите сумму счета, ₽:</label
                    ></b-col
                  >
                  <b-col
                    ><b-form-input
                      id="amount-input"
                      v-model="file_form.payment_amount"
                      placeholder="2000"
                      required
                      v-bind:class="{
                        'is-valid': dirty && valid,
                        'is-invalid': dirty && invalid,
                      }"
                    ></b-form-input>
                    <div
                      v-if="errors && errors.length != 0"
                      class="invalid-feedback d-inline-block"
                    >
                      <ul>
                        <li v-for="error in errors">{{ error }}</li>
                      </ul>
                    </div>
                  </b-col>
                </b-form-row>
              </validation-provider>
            </b-form-row>

            <validation-provider
              name="Статус"
              :rules="{
                required: true,
              }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-row class="mb-2">
                <b-dropdown
                  class="position-static text-nowrap"
                  id="dropdown-1"
                  size="sm"
                  :text="file_form.status ? file_form.status : 'Выбрать статус'"
                  :variant="
                    file_form.status
                      ? file_form.status_color[file_form.status]
                      : 'dark'
                  "
                  v-model="file_form.status"
                >
                  <b-dropdown-item-button @click="file_form.status = 'Оплачено'"
                    >Оплачено</b-dropdown-item-button
                  >
                  <b-dropdown-item-button
                    @click="file_form.status = 'Не оплачено'"
                    >Не оплачено</b-dropdown-item-button
                  >
                  <b-dropdown-item-button
                    @click="file_form.status = 'Просмотрено'"
                    >Просмотрено</b-dropdown-item-button
                  >
                  <b-dropdown-item-button
                    @click="file_form.status = 'Не просмотрено'"
                    >Не просмотрено</b-dropdown-item-button
                  >
                </b-dropdown>
              </b-form-row>
            </validation-provider>

            <validation-provider
              name="Тип"
              :rules="{
                required: true,
              }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-row class="mb-2">
                <b-dropdown
                  class="position-static text-nowrap"
                  id="dropdown-1"
                  size="sm"
                  :text="file_form.type ? file_form.type : 'Выбрать тип'"
                  :variant="
                    file_form.type
                      ? file_form.type_color[file_form.type]
                      : 'dark'
                  "
                  v-model="file_form.type"
                >
                  <b-dropdown-item-button @click="file_form.type = 'Счет'"
                    >Счет</b-dropdown-item-button
                  >
                  <b-dropdown-item-button @click="file_form.type = 'Отчет'"
                    >Отчет</b-dropdown-item-button
                  >
                </b-dropdown>
              </b-form-row>
            </validation-provider>

            <validation-provider
              name="Имя файла"
              :rules="{
                required: true,
              }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-row class="mb-2">
                <b-form-input
                  v-model="file_form.filename"
                  placeholder="Имя файла"
                  required
                  v-bind:class="{
                    'is-valid': dirty && valid,
                    'is-invalid': dirty && invalid,
                  }"
                ></b-form-input>
              </b-form-row>
            </validation-provider>

            <b-form-row class="mb-5">
              <b-form-file
                v-model="file"
                :state="Boolean(file)"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                accept=".pdf"
                required
              ></b-form-file>
            </b-form-row>

            <b-form-row class="mt-5">
              <b-col
                ><b-button
                  class="col-12"
                  variant="outline-primary"
                  @click="$bvModal.hide('modal-1')"
                >
                  Отмена
                </b-button></b-col
              >
              <b-col
                ><b-button
                  class="col-12"
                  variant="primary"
                  type="submit"
                  :disabled="!valid"
                >
                  Загрузить
                </b-button></b-col
              >
            </b-form-row>
          </b-form>
        </ValidationObserver>
      </b-modal>

      <b-modal
        :id="`modal-2`"
        hide-footer
        header-class="align-items-center pt-reduced pb-reduced"
      >
        <template #modal-header="{ close }">
          <h5 class="mb-0">Пополнить баланс</h5>

          <b-button
            variant="text"
            @click="close()"
            class="btn-close bg-transparent p-0 d-flex align-items-center justify-content-center"
            style="min-height: 24px"
          >
            <i
              class="ri-close-line hp-text-color-dark-0 lh-1"
              style="font-size: 24px"
            ></i>
          </b-button>
        </template>
        <ValidationObserver v-slot="{ valid }">
          <b-form class="col-12" @submit="onBalanceUpdate">
            <b-form-row>
              <validation-provider
                name="Цена"
                :rules="{
                  required: true,
                  regex: /^\d+([\.]\d+)?$/,
                }"
                v-slot="{ dirty, valid, invalid, errors }"
              >
                <b-form-row class="mb-2">
                  <b-col
                    ><label inline class="mr-sm-2" for="amount-input"
                      >Введите сумму, ₽:</label
                    ></b-col
                  >
                  <b-col
                    ><b-form-input
                      id="amount-input"
                      v-model="balanceUpdateAmount"
                      placeholder="2000"
                      required
                      v-bind:class="{
                        'is-valid': dirty && valid,
                        'is-invalid': dirty && invalid,
                      }"
                    ></b-form-input>
                    <div
                      v-if="errors && errors.length != 0"
                      class="invalid-feedback d-inline-block"
                    >
                      <ul>
                        <li v-for="error in errors">{{ error }}</li>
                      </ul>
                    </div>
                  </b-col>
                </b-form-row>
                <b-form-row class="mb-2">
                  <b-col><label inline class="mr-sm-2" for="date-input">Введите дату:</label></b-col>
                  <b-col><b-form-input size="sm" type="date" required v-model="balanceUpdateDate"/></b-col>
                </b-form-row>
              </validation-provider>
            </b-form-row>

            <b-form-row class="mt-5">
              <b-col
                ><b-button
                  class="col-12"
                  variant="outline-primary"
                  @click="$bvModal.hide('modal-2')"
                >
                  Отмена
                </b-button></b-col
              >
              <b-col
                ><b-button
                  class="col-12"
                  variant="primary"
                  type="submit"
                  :disabled="!valid"
                >
                  Пополнить
                </b-button></b-col
              >
            </b-form-row>
          </b-form>
        </ValidationObserver>
      </b-modal>
    </b-row>
    <b-row>
      <b-col>
        <b-tabs>
          <b-tab title="Документы" active>
            <DocumentsTable class="mt-3" />
          </b-tab>
          <b-tab title="История списаний">
            <BillingTable class="mt-3" />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import {
  BTabs,
  BTab,
  BRow,
  BCol,
  BCard,
  BButton,
  BFormFile,
  BForm,
  BFormRow,
  BFormInput,
  BModal,
  BDropdown,
  BDropdownItemButton,
} from "bootstrap-vue";

import BillingTable from "./BillingTable.vue";
import DocumentsTable from "./DocumentsTable.vue";
import axios from "axios";

export default {
  data() {
    return {
      balance: null,
      price: null,
      unit: null,

      file: null,
      balanceUpdateAmount: null,
      balanceUpdateDate: new Date(),
      file_form: {
        status_color: {
          "Оплачено": "outline-success",
          "Не оплачено": "outline-danger",
          "Просмотрено": "outline-primary",
          "Не просмотрено": "outline-dark",
        },

        type_color: {
          Счет: "outline-success",
          Отчет: "outline-primary",
        },

        payment_amount: null,
        status: null,
        type: null,
        filename: null,
      },
    };
  },
  components: {
    BRow,
    BTabs,
    BTab,
    BCol,
    BCard,
    BButton,
    DocumentsTable,
    BillingTable,
    BFormFile,
    BForm,
    BFormRow,
    BFormInput,
    BModal,
    BDropdown,
    BDropdownItemButton,
  },
  async mounted() {
    var inn = this.$route.params.inn;
    if (!inn) {
      inn = this.$store.state.user["inn"];
    }

    const { data } = await axios.get(
      `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/billing/short/${inn}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log(data);
    this.balance = data["balance"];
  },
  methods: {
    async onBalanceUpdate(event) {
      event.preventDefault();

      var inn = this.$route.params.inn;
      if (!inn) {
        inn = this.$store.state.user["inn"];
      }
      const resp = await axios.post(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/billing/${inn}/update_bill`,
        {
          balanceUpdateAmount: this.balanceUpdateAmount,
          balanceUpdateDate: this.balanceUpdateDate,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(resp);
      this.$router.go();
    },
    async onUpload(event) {
      event.preventDefault();
      if (!this.file) {
        alert("No file chosen");
        return;
      }

      if (this.file.size > 4 * 1024 * 1024) {
        alert("File too big (> 4MB)");
        return;
      }

      var inn = this.$route.params.inn;
      if (!inn) {
        inn = this.$store.state.user["inn"];
      }

      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("modified", this.file.lastModifiedDate);
      formData.append("created", this.file.lastModifiedDate);
      formData.append("payment_amount", this.file_form.payment_amount);
      formData.append("status", this.file_form.status);
      formData.append("filename", this.file_form.filename);
      formData.append("type", this.file_form.type);

      const resp = await axios.post(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/documents/${inn}/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(resp);
      this.$router.go();
    },
  },
  watch: {
    file: function (val) {
      if (!this.file_form.filename) {
        this.file_form.filename = val.name;
      }
    },
  },
};
</script>
